import React, { useEffect, useState } from 'react';
import { useLanguage } from '../providers/preferenceProvider';
import logo from '../media/logo.svg';
import '../css/login.css';
import { ApiClient } from '../api/api-client';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useConfig } from '../providers/configProvider';
import { useToast } from '../providers/toastProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
  const { refresh } = useConfig();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { showToast, showLoading, hideLoading } = useToast();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    ApiClient.getInstance().getSession()
      .then((response) => {
        const isSystem = response.data.systemAccount === true;
        const target = isSystem ? '/display' : '/home';
        navigate(target, { replace: true });
      })
      .catch((error) => {
      });
  }, [navigate]);
  

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  function handleLogin(e) {
    showLoading();
    e.preventDefault();
    ApiClient.getInstance().login(email, password)
      .then(() => {
        return refresh();
      })
      .then(() => {
        return ApiClient.getInstance().getSession();
      })
      .then((response) => {
        const isSystem = response.data.systemAccount === true;
        let target;
        if (isSystem) {
          target = '/display';
        } else {
          target = sessionStorage.getItem('redirectAfterLogin') || '/home';
        }
        sessionStorage.removeItem('redirectAfterLogin');
        hideLoading();
        navigate(target, { replace: true });
      })
      .catch((error) => {
        showToast('Login failed. Email or username was incorrect.', 'error');
        setPassword('');
        hideLoading();
      });
  }

  return (
    <>
      <div>
        <main className="main-container">
          <div className="login-box">
            <div className="main-header">{t.login}</div>
            <div className="form-container">
              <div className="login-content">
                <div className="welcome-text">{t.welcome}!</div>
                <form className="login-form"  onSubmit={handleLogin}>
                  <input
                    type="text" 
                    placeholder={t.email + "..."} 
                    value={email} 
                    onChange={handleEmailChange} 
                    required 
                  />
                  <div className="relative w-full">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder={t.password + "..."}
                      value={password}
                      onChange={handlePasswordChange}
                      required
                      className="no-browser-eye w-full pr-10 pl-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <FontAwesomeIcon
                      icon={showPassword ? faEyeSlash : faEye}
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                    />
                  </div>

                  <div className="login-atributes-wrapper">
                    <Link to="/forgot-password" className="forgot-password-link">{t.forgot_password}</Link>
                  </div>
                  <button className="mb-2" type="submit">{t.login}</button>
                </form>
              </div>
              <div className="login-logo">
                <img src={logo} alt="42Workspace" />
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Login;
